import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { Observable } from 'rxjs';

import { BlogService } from '@services/blog.service';

export const blogArticleResolver: ResolveFn<Observable<any>> = (route, state) => {
  const blogService = inject(BlogService);
  const id = route.params['id'] || '1';

  return blogService.loadArticle(id);
};
